module.exports = __webpack_public_path__ + "img/dmg.5009e1c.svg";